import Carousel from "bootstrap/js/dist/carousel";

export default function CarouselAutoSlide(carouselId) {
  const carouselEl = document.querySelector(carouselId);
  if(carouselId === "#carouselHome"){

    const _i = document.querySelector('.carousel-indicators');
    if (typeof(_i) != 'undefined' && _i != null) {
      const allIndicator = document.querySelector('.carousel-indicators').children;
      const allSlides = carouselEl.querySelectorAll('.carousel-item');

      const indicatorArray = Array.from(allIndicator);

      const indicatorsNotInLocale = indicatorArray.filter(element => !!element.getAttribute('data-country')
        && element.getAttribute('data-country') !== GEOIP.country);

      const slidesNotInLocale = Array.from(allSlides).filter(element => {
        const children = Array.from(element.children);
        return children.some(child => !!child.getAttribute('data-country') && child.getAttribute('data-country') !== GEOIP.country);
      });

      for (let i = 0; i < indicatorsNotInLocale.length; i++) {
        const eleIndex = indicatorArray.findIndex((ele) => ele === indicatorsNotInLocale[i]);
        indicatorsNotInLocale[i].remove();
        slidesNotInLocale[i].remove();
        for (let j = eleIndex + 1; j < indicatorArray.length; j++) {
          const nextIndicator = indicatorArray[j];
          nextIndicator.setAttribute('data-bs-slide-to', j - 1);
        }
      }
    }
  }

  if (carouselEl) {
    const carousel = new Carousel(carouselEl, {
      interval: 5000
    });

    let carouselOnResize = () => {
      if (window.innerWidth >= 992) {
        carousel.pause();
      } else {
        carousel.cycle();
      }
    };

    carouselOnResize();

    window.addEventListener("resize", () => {
      carouselOnResize();
    });
  }
}
